// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"122":"password-data","417":"browscap-data"}[chunkId] + "-legacy." + {"122":"901c35fa","417":"46e08041"}[chunkId] + ".js";
};